import type { IconData } from '@stacksjs/iconify-core'

export const mailSend: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M13.412 34.508c.158 1.698 1.482 2.974 3.182 3.103C19.018 37.794 23.067 38 29 38s9.982-.206 12.406-.39c1.7-.128 3.024-1.404 3.182-3.102c.2-2.151.412-5.589.412-10.508c0-4.92-.212-8.357-.412-10.508c-.158-1.698-1.482-2.974-3.182-3.103C38.982 10.206 34.934 10 29 10s-9.982.206-12.405.39c-1.7.128-3.025 1.404-3.183 3.102C13.212 15.643 13 19.08 13 24s.212 8.357.412 10.508Z\"/><path stroke-linecap=\"round\" d=\"M13 22s11.616 6 16 6c4.383 0 16-6 16-6M3 17h5m-4 7h4m-3 7h3\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default mailSend
